import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { xeroApi } from "../api/xero";
import type { ImportXeroEmployeesPayload } from "../api/xero";
import { requireData } from "./http";
import { userQueryKeys } from "./users";
import { invalidateDashboard } from "./dashboard";

export const xeroEmployeeQueryOptions = (tenantId: string) =>
  queryOptions({
    queryKey: ["xero", "employees", tenantId] as const,
    queryFn: async ({ signal }) =>
      requireData(await xeroApi.previewEmployees(tenantId, signal)),
    staleTime: 0,
  });

export const useXeroEmployees = (tenantId: string) =>
  useQuery(xeroEmployeeQueryOptions(tenantId));

export const useImportXeroEmployees = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      tenantId,
      payload,
    }: {
      tenantId: string;
      payload: ImportXeroEmployeesPayload;
    }) => requireData(await xeroApi.importEmployees(tenantId, payload)),
    onSuccess: async (_, { tenantId }) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: xeroEmployeeQueryOptions(tenantId).queryKey,
        }),
        queryClient.invalidateQueries({ queryKey: userQueryKeys.all }),
        invalidateDashboard(queryClient),
      ]);
    },
  });
};
